var styles = {
  "unit-base": "4"
};

var UNIT = Number(styles['unit-base']);
var unit = function unit(modifier) {
  return modifier * UNIT;
};
var Spacing = function (Spacing) {
  Spacing[Spacing["XSmall"] = unit(0.5)] = "XSmall";
  Spacing[Spacing["Small"] = unit(1)] = "Small";
  Spacing[Spacing["Regular"] = unit(2)] = "Regular";
  Spacing[Spacing["Medium"] = unit(3)] = "Medium";
  Spacing[Spacing["Large"] = unit(4)] = "Large";
  Spacing[Spacing["XLarge"] = unit(6)] = "XLarge";
  Spacing[Spacing["X2Large"] = unit(8)] = "X2Large";
  Spacing[Spacing["X3Large"] = unit(12)] = "X3Large";
  Spacing[Spacing["X4Large"] = unit(16)] = "X4Large";
  Spacing[Spacing["X5Large"] = unit(24)] = "X5Large";
  Spacing[Spacing["X6Large"] = unit(32)] = "X6Large";
  return Spacing;
}({});

export { Spacing, unit };
//# sourceMappingURL=spacing.js.map
